import { render } from "./TinyMceView.vue?vue&type=template&id=32ce2ec2&scoped=true&ts=true"
import script from "./TinyMceView.vue?vue&type=script&lang=ts"
export * from "./TinyMceView.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32ce2ec2"]])

export default __exports__